const Constant = {
    PAGINATION_SIZE: 20,
    DEBOUNCE_DELAY: 500,
    DATE_FORMAT: 'MM-dd-yyyy',
    DATE_RANGE_FORMAT: 'yyyy-MM-dd',
    DATE_FORMAT_WITH_TIME: 'MM-dd-yyyy hh:mm:ss',
    DATE_FORMAT_FOR_DATABASE:'yyyy-MM-DD HH:MM:SS',
    DATE_FORMAT_WITH_TIME_SEPERATED_BY_SLASH: 'MM/dd/yyyy hh:mm:ss a',
    INVOICE_DATE_FORMAT: 'LLL d, yyyy',
    PRINT_INVOICE_PERIOD_START_DATE_FORMAT: 'LLL d, yyyy',
    PRINT_INVOICE_PERIOD_END_DATE_FORMAT: 'LLL d, yyyy',
}

Object.freeze(Constant)

export default Constant
